module.exports = __webpack_public_path__ + "static/media/jp-splash-photo-right.2405c1cb.jpg";